/* eslint complexity: ["error", 7] */
import { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { Box, CurrencyInput, Flex, Radio, RadioGroup } from '@cof/plastic-components';
import { Controller, useFormContext } from 'react-hook-form';

import { FORM_SECTIONS } from './FormIDs';
import { LabelSection } from '../../../components/TextField/TextField';
import { FormUtilsContext } from '../QuickCheck';
import ErrorHandler, { shouldDisplayFormTick, shouldDisplayRadioTick } from './ErrorHandler';
import { withText } from '../../../text/textStore';
import Group from '../../../components/Group';
import { useFormData } from '../../../components/FormDataContext';

const interestedInBTOptions = {
    Yes: 'Y',
    No: 'N'
};

const BalanceTransfer = ({ Text }: any) => {
    const {
        formState: { errors, touchedFields },
        getValues,
        setValue,
        register,
        watch
    } = useFormContext();

    const aboutYouIds = FORM_SECTIONS.AboutYou;
    // @ts-expect-error TS2339: Property 'variantTernary' does not exist on type 'null'.
    const { variantTernary } = useContext(FormUtilsContext); // TODO: Further Improvement - Create a custom hook for this
    // @ts-expect-error TS2339: Property 'isEdit' does not exist on type 'unknown'.
    const { isEdit, formData } = useFormData();

    const [interestedInBT, setIsInterestedInBT] = useState(isEdit && !!formData?.formValues?.[aboutYouIds.BTAmount]);

    useEffect(() => {
        if (isEdit) {
            const requestedBT = formData.formValues[aboutYouIds.BTAmount] > 0;
            // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            setValue(aboutYouIds.InterestedInBT, requestedBT ? 'Y' : 'N');
            setIsInterestedInBT(requestedBT);
        } else {
            // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            setValue(aboutYouIds.InterestedInBT, 'Y');
            setIsInterestedInBT(true);
        }
    }, [formData, aboutYouIds, setValue, isEdit]);

    useEffect(() => {
        if (!interestedInBT) {
            // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
            setValue(aboutYouIds.BTAmount, '');
        }
    }, [aboutYouIds, setValue, interestedInBT]);

    return (
        <Box mt="xs" mb="sm" data-qa-id="group-balance-transfer">
            <Group as="fieldset">
                <LabelSection
                    id={aboutYouIds.InterestedInBT}
                    label={<Text path="InterestedInBT" />}
                    // @ts-expect-error TS2554: Expected 5 arguments, but got 3.
                    displayTick={shouldDisplayRadioTick(aboutYouIds.InterestedInBT, watch, errors)}
                    data-qm-allow
                    as="legend"
                />
                <Flex>
                    <RadioGroup
                        paddingTop={'xs'}
                        // @ts-expect-error TS2322: Type 'string | undefined' is not assignable to type 'string'.
                        name={aboutYouIds.InterestedInBT}
                        variant="square"
                        optionWrapperProps={{
                            width: '9.7rem'
                        }}
                        data-qm-allow
                    >
                        {Object.entries(interestedInBTOptions).map(([displayName, value]) => (
                            <Radio
                                key={`${aboutYouIds.InterestedInBT}-${value}`}
                                value={value}
                                onClick={() => setIsInterestedInBT(displayName === 'Yes')}
                                // @ts-expect-error TS2345: Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
                                {...register(aboutYouIds.InterestedInBT)}
                                aria-describedby={`${aboutYouIds.InterestedInBT}-error`}
                                data-qm-allow
                            >
                                {displayName}
                            </Radio>
                        ))}
                    </RadioGroup>
                </Flex>
            </Group>
            <Box display={interestedInBT ? 'block' : 'none'} mt="md" data-qa-id={`${aboutYouIds.BTAmount}-container`}>
                <Group>
                    <LabelSection
                        id={aboutYouIds.BTAmount}
                        label={<Text path="BTAmount"></Text>}
                        displayTick={shouldDisplayFormTick(aboutYouIds.BTAmount, getValues, errors)}
                        px="0"
                        data-qm-allow
                    />

                    <Controller
                        // @ts-expect-error TS2322: Type 'string | undefined' is not assignable to type 'string'.
                        name={aboutYouIds.BTAmount}
                        id={aboutYouIds.BTAmount}
                        rules={{
                            required: interestedInBT ? 'Please enter a balance transfer amount' : false,
                            validate: (value: any) => {
                                if (interestedInBT && value < 50) {
                                    return 'Balance transfer amount must be at least £50';
                                }
                                return true;
                            }
                        }}
                        render={({ field }: any) => (
                            <CurrencyInput
                                id={aboutYouIds.BTAmount}
                                name={field.name}
                                value={field.value ?? ''}
                                onValueChange={(value: any) => {
                                    field.onChange(value ?? '');
                                }}
                                onBlur={field.onBlur}
                                data-qa-id={aboutYouIds.BTAmount}
                                maxLength={7}
                                allowDecimals={false}
                                allowNegativeValue={false}
                                variant={variantTernary(aboutYouIds.BTAmount)}
                                aria-describedby={`${aboutYouIds.BTAmount}-error`}
                            />
                        )}
                    />
                    {/* @ts-expect-error TS2538: Type 'undefined' cannot be used as an index type. */}
                    <ErrorHandler id={aboutYouIds.BTAmount} show={touchedFields[aboutYouIds.BTAmount]} data-qm-allow />
                </Group>
            </Box>
        </Box>
    );
};

BalanceTransfer.propTypes = {
    Text: PropTypes.func.isRequired
};

BalanceTransfer.displayName = 'BalanceTransfer';

export default withText('AboutYou')(BalanceTransfer);
